import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 7.75A.75.75 0 0 1 7.25 7V5.75H4a.25.25 0 0 0-.25.25v13c0 .138.112.25.25.25h1a.75.75 0 0 1 0 1.5H4A1.75 1.75 0 0 1 2.25 19V6c0-.966.784-1.75 1.75-1.75h3.25V3a.75.75 0 0 1 1.5 0v1.25h6.5V3a.75.75 0 0 1 1.5 0v1.25H20c.966 0 1.75.784 1.75 1.75v1a.75.75 0 0 1-1.5 0V6a.25.25 0 0 0-.25-.25h-3.25V7a.75.75 0 0 1-1.5 0V5.75h-6.5V7a.75.75 0 0 1-.75.75M7.25 20a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m12.5-10a.75.75 0 0 0-1.5 0v1.25H16.5a.75.75 0 0 0 0 1.5h4.65l-.812 6.5H19a.75.75 0 0 0 0 1.5h1.823a.95.95 0 0 0 .943-.832l.95-7.6a.95.95 0 0 0-.943-1.068H19.75zm-4.704 6.25a4.8 4.8 0 0 0-.614-1.242c-.486-.686-1.226-1.258-2.432-1.258s-1.946.572-2.432 1.258a4.8 4.8 0 0 0-.614 1.242zm-6.702-2.109c.703-.993 1.862-1.891 3.656-1.891s2.953.898 3.656 1.891c.683.965.95 2.03 1.042 2.492.123.62-.372 1.117-.925 1.117H8.227c-.553 0-1.048-.496-.925-1.117.092-.463.359-1.527 1.042-2.492",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }